export interface BatchSchoolStatisticsBestReaderRequest {
  lendDateFrom: string
  lendDateTo: string
  lendType: number[]
  collectionTypeFrom: string
  collectionTypeTo: string
  rdoBunruiType: string
  bunruiFrom: string
  bunruiTo: string
  orderLimit: string
  isStatisticsBranch: boolean
  isStatisticsGrade: boolean
  isStatisticsClass: boolean
  isStatisticsGender: boolean
  isStatisticsAge: boolean
  isStatisticsSearchType: boolean
  isStatisticsMaterialFormat: boolean
  branch: string
  grade: string
  class: string
  gender: string
  age: string
  searchType: string
  materialFormat: string
  memo: string
  batchType: string
}

export function BatchSchoolStatisticsBestReaderRequestToJSON(
  value: BatchSchoolStatisticsBestReaderRequest
): any {
  return {
    lend_date_from: value.lendDateFrom,
    lend_date_to: value.lendDateTo,
    lend_type: value.lendType,
    collection_type_from: value.collectionTypeFrom,
    collection_type_to: value.collectionTypeTo,
    rdo_bunrui_type: value.rdoBunruiType,
    bunrui_from: value.bunruiFrom,
    bunrui_to: value.bunruiTo,
    order_limit: value.orderLimit,
    is_statistics_branch: value.isStatisticsBranch,
    is_statistics_grade: value.isStatisticsGrade,
    is_statistics_class: value.isStatisticsClass,
    is_statistics_gender: value.isStatisticsGender,
    is_statistics_age: value.isStatisticsAge,
    is_statistics_search_type: value.isStatisticsSearchType,
    is_statistics_material_format: value.isStatisticsMaterialFormat,
    branch: value.branch,
    grade: value.grade,
    class: value.class,
    gender: value.gender,
    age: value.age,
    search_type: value.searchType,
    material_format: value.materialFormat,
    memo: value.memo,
    batch_type: value.batchType
  }
}
